
/*
Copyright (c) 2020 by Stevie. All Rights Reserved.
*/
import React,{FunctionComponent} from 'react'
import styled from 'styled-components';
import {StyledSpan } from '../../libs/base/base-style'




type CircleProps = {
  size:string;
  fillColor:string;
}


/*
带图标 单行提示
*/
const BasicCircle:FunctionComponent<CircleProps> = (props) => {
  return (
    <StyledSpan {...props}>
    </StyledSpan>
  )
}

const Circle = styled(BasicCircle).attrs(({ size,fillColor }) => ({
  size,
  fillColor
}))`
  width:${props => props.size};
  height:${props => props.size};
  border-radius: 50%;
  background:${props => props.fillColor};
  display:inline-block;
  vertical-align:middle;
`

export default Circle
